import { VNode } from "preact"
import { Logo } from "@/app/logo"
import { ComponentProps } from "./type.tsx"

interface CenterColumnContainerProps extends ComponentProps {
  logo?: VNode
  title?: string
  subtitle?: string
}

export function CenterColumnContainer(props: CenterColumnContainerProps) {
  return (
    <div class="min-h-screen bg-white">
      <div class="max-w-lg mx-auto px-6 pt-24">
        <div class="flex justify-center mb-16">{props.logo ?? <Logo />}</div>

        {props.title && (
          <div class="mb-8">
            <h1 class="text-2xl font-semibold text-gray-900 mb-2">{props.title}</h1>
            {props.subtitle && <p class="text-gray-500">{props.subtitle}</p>}
          </div>
        )}

        <div class="bg-white border border-gray-200 rounded-lg p-6">{props.children}</div>
      </div>
    </div>
  )
}
